import { useQuery } from "@hooks/useQuery";
import { Icon } from "@iconify/react";
import { Button, Tabs } from "antd";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import HeaderManagment from "../Header/HeaderManagment";
import FooterPassenger from "../footer/FooterPassenger";

export const Navigation: React.FC = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const activeTab = query.get("activeTab");
  const subActiveTab = query.get("subActiveTab");
  const thirdSubActiveTab = query.get("thirdSubActiveTab");

  console.log(activeTab, "activeTabtest");

  useEffect(() => {
    if (query.get("id")) {
      return;
    }
    if (!activeTab) {
      navigate(`${window.location.pathname}?activeTab=passengerHeader&subActiveTab=mainheaders`, { replace: true });
    } else if (activeTab === "passengerFooter" && !subActiveTab) {
      navigate(`${window.location.pathname}?activeTab=passengerFooter&subActiveTab=aboutAndLegal`, {
        replace: true,
      });
    }
  }, [navigate, activeTab, subActiveTab]);

  const items = [
    { label: "Header", key: "passengerHeader", children: <HeaderManagment /> },
    { label: "Footer", key: "passengerFooter", children: <FooterPassenger /> },
  ];

  const handleHeaderAction = (activeTab?: string | null) => {
    if (subActiveTab === "mainheaders") {
      return (
        <Button
          icon={<Icon icon="lucide:plus" />}
          onClick={() => navigate("/dedicated/passenger/navigation/header/main/add")}
        >
          Add Main Header
        </Button>
      );
    }

    if (subActiveTab === "childheader") {
      return (
        <Button
          icon={<Icon icon="lucide:plus" />}
          onClick={() => navigate("/dedicated/passenger/navigation/header/child/add")}
        >
          Add Child Header
        </Button>
      );
    }

    if (subActiveTab === "grandchildheader") {
      return (
        <Button
          icon={<Icon icon="lucide:plus" />}
          onClick={() => navigate("/dedicated/passenger/navigation/header/grandchild/add")}
        >
          Add Grand Child Header
        </Button>
      );
    }

    if (thirdSubActiveTab === "servicePortals") {
      return (
        <Button
          onClick={() => {
            navigate("/dedicated/passenger/navigation/footer/icons/servicePortals/add");
          }}
          icon={<Icon icon="lucide:plus" />}
        >
          Add Service Portal
        </Button>
      );
    }
    if (thirdSubActiveTab === "socialMedia") {
      return (
        <Button
          onClick={() => {
            navigate("/dedicated/passenger/navigation/footer/icons/socialMedia/add");
          }}
          icon={<Icon icon="lucide:plus" />}
        >
          Add Social Media
        </Button>
      );
    }

    return null;
  };

  const airportTextMap: Record<string, string> = {
    passengerHeader: "Global/Non-Airport Specific Content",
    passengerFooter: "Global (Non-Airport) & Corporate Site Content",
  };

  const airportText = airportTextMap[activeTab || "passengerHeader"];

  return (
    <ContentWrapper
      title="Navigation"
      bodyStyle={{ height: "calc(100vh - 100px)", overflowY: "auto" }}
      actionItems={handleHeaderAction(activeTab)}
      airportText={airportText}
    >
      <Tabs
        activeKey={activeTab || "passengerHeader"}
        items={items}
        onChange={(activeKey) => {
          const defaultSubTab = activeKey === "passengerHeader" ? "mainheaders" : "aboutAndLegal";

          navigate(`${window.location.pathname}?activeTab=${activeKey}&subActiveTab=${defaultSubTab}`);
        }}
      />
    </ContentWrapper>
  );
};

export default Navigation;
